<template>
    <div>
        <el-dialog :visible.sync="cmdDetailDialog" width="80%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
            <el-card style="height: 560px">
                <el-tabs type="border-card" v-model="activceName">
                    <el-tab-pane label="指令记录" name="1">
                         <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                                   style="margin:auto;width:calc(100% - 30px)" height="450" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                                   :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                            <el-table-column label="操作批次" align="center" prop="id" width="200"  v-if="false"></el-table-column>
                            <el-table-column label="类型" align="center" prop="operationType" width="120"></el-table-column>
                            <el-table-column label="类型描述" align="center" prop="operationTypeStr" width="160"></el-table-column>
                            <el-table-column label="结果描述" align="center" prop="operationResultStr" width="120"></el-table-column>
                            <el-table-column label="充电柜编号" align="center" prop="powerBoxId"></el-table-column>
                            <el-table-column label="充电宝编号" align="center" prop="powerBankId"></el-table-column>
                            <el-table-column label="插槽" align="center" prop="slot"></el-table-column>
                            <el-table-column label="关联订单" align="center" prop="orderId"></el-table-column>
                            <el-table-column label="操作时间" align="center" width="180">
                                <template slot-scope="scope">{{ scope.row.operationTime | formatDate}}</template>
                            </el-table-column>
                        </el-table>
                        <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
import {getDeviceCmdById} from "../../../api/warehousedevice/warehousedevice.js";
import { formatDate } from "../../../utils/date.js";
export default {
    data() {
        return {
            response: {data: [],total: 0},
            query: {current: 1, size: 50},
            loading: false,
            cmdDetailDialog: false,
            activceName: "1",
            deviceId: null
        }
    },
    methods: {
        init(deviceId){
            this.cmdDetailDialog = true;
            this.deviceId = deviceId;
            getDeviceCmdById({current: this.query.current,size: this.query.size},deviceId).then(result=>{
                this.response.data = result.data.records;
                this.response.total = result.data.total;
            })
        },
        currenChangeHandle(value){
            this.query.current = value;
            this.init(this.deviceId);
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.activceName = "1";
            this.response.data = ''
        } 
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
.el-pagination{
    margin-left: 30%;
}
</style>


// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/cmddetail.vue